export default __webpack_public_path__ + "static/space-d6f0feda08700cd790efd6c126b7f717.mp4";